import * as React from 'react';
import * as Styled from './form-field-label.styled';
export const FormFieldLabel = React.memo(function FormFieldLabel({
  children
}: React.PropsWithChildren) {
  return <Styled.LabelText>{children}</Styled.LabelText>;
});